/**
 * Created by Teo on 05/04/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasesAggregatedPerEmployee', {
                parent: 'purchasesAggregated',
                url: '/perEmployee',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP'],
                    pageTitle: 'Purchases Aggregated Per Employee'
                },
                templateUrl: 'app/displays/adminIndex/purchasesAggregated/perEmployee/purchasesAggregatedPerEmployee.html',
                controller: 'PurchasesAggregatedPerEmployeeController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
